module.exports = __webpack_public_path__ + "static/media/Label.new.7bc8dc6e.svg";